// UI-side caps applied while the database backfill catches up. Old rows
// can come back with inflated power-level or bracket numbers; cap them at
// display time so listings/aggregates never show values above the band the
// algorithm produces today. The deck-details route renders refreshed data
// straight from the API and intentionally bypasses these caps.

export const POWER_LEVEL_DISPLAY_CAP = 10.9;
export const BRACKET_DISPLAY_CAP = 5.9;

export function capPowerLevel(value) {
    if (value == null) return value;
    const n = Number(value);
    if (!Number.isFinite(n)) return value;
    return n > POWER_LEVEL_DISPLAY_CAP ? POWER_LEVEL_DISPLAY_CAP : n;
}

export function capBracketRating(value) {
    if (value == null) return value;
    const n = Number(value);
    if (!Number.isFinite(n)) return value;
    return n > BRACKET_DISPLAY_CAP ? BRACKET_DISPLAY_CAP : n;
}

const SORT_TO_CAP = {
    POWERLEVEL: capPowerLevel,
    BRACKET: capBracketRating,
};

// Cap the score-column value based on which sort axis is active. Returns
// the input untouched for sort axes we don't cap (salt, count, ingest).
export function capDisplayValueForSort(value, sortEnum) {
    const cap = SORT_TO_CAP[sortEnum];
    return cap ? cap(value) : value;
}
